























import Vue from 'vue';
import Component from 'vue-class-component';

import { MetaInfo } from 'vue-meta';

// Static import for faster rendering
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

/** App is the main component */
@Component({
	components: {
		Header,
		Footer
	}
})
export default class App extends Vue {
	/** The meta informations of the route */
	metaInfo(): MetaInfo {
		return {
			// If no subcomponents specify a metaInfo.title, this title will be used
			title: this.$t('common.meta.title') as string,
			// All titles will be injected into this template
			titleTemplate: this.$t('common.meta.titleTemplate') as string,
			meta: [
				{
					name: 'description',
					content: this.$t('common.meta.description') as string
				}
			]
		};
	}
}
